import { useMemo } from 'react'
import { IAuthScriptOptions } from '@/actors/AuthActor/types'
import { resolveAuthTheme, ResolvedAuthTheme } from '@/actors/AuthActor/theme/resolveAuthTheme'

interface UseAuthThemeParams {
  options?: IAuthScriptOptions
  activeForm: string
}

/**
 * Turns the scene's theme tokens into CSS custom properties for the current
 * form. The vars are set once on the auth root; every component below reads
 * them through `var(--token, <design-system default>)`, so nothing needs a
 * `Themed*` wrapper and hover/focus/active stay in CSS.
 */
export const useAuthTheme = ({ options, activeForm }: UseAuthThemeParams): ResolvedAuthTheme => {
  return useMemo(() => resolveAuthTheme(options, activeForm), [options, activeForm])
}
